export const removeBase64Images = (html) => {
  return html.replace(/<img[^>]*src=["']data:image\/[^"']+["'][^>]*>/g, "");
};
